import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { onAuthEvent } from '@/api/auth-events';
import { queryKeys } from '@/api/queries/keys';
import { stopActAs } from '@/api/queries/platform';

/** Root route: turns API-client events (expired session, suspension) into navigation. */
export function AuthEventsBridge() {
  const navigate = useNavigate();
  const location = useLocation();
  const qc = useQueryClient();

  useEffect(
    () =>
      onAuthEvent((event) => {
        if (event === 'session-expired') {
          qc.removeQueries({ queryKey: queryKeys.me });
          const next = encodeURIComponent(location.pathname + location.search);
          void navigate(`/login?reason=expired&next=${next}`, { replace: true });
        } else if (event === 'tenant-suspended') {
          void navigate('/suspended', { replace: true });
        } else if (event === 'act-as-ended') {
          // Back to the support person's own session.
          void stopActAs().finally(() => window.location.assign('/admin'));
        } else {
          qc.clear();
          void navigate('/account-disabled', { replace: true });
        }
      }),
    [navigate, location, qc],
  );

  return <Outlet />;
}
